// extracted by mini-css-extract-plugin
module.exports = {"container":"ContextMenu_container__N2b45","rectangle":"ContextMenu_rectangle__S6c69"};